import React from 'react';
import { Menu } from 'lucide-react';
import ThemeToggle from './theme/ThemeToggle';

const MobileHeader = ({ onMenuClick }) => {
  return (
    <div className="lg:hidden fixed top-0 left-0 right-0 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 z-40 transition-colors">
      <div className="flex items-center justify-between px-4 py-3">
        <button
          onClick={onMenuClick}
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        >
          <Menu className="w-6 h-6 text-gray-700 dark:text-gray-300" />
        </button>
        <img src="/logo_1.png" alt="Classtraks Logo" className="h-10 md:h-12" />
        <ThemeToggle />
      </div>
    </div>
  );
};

export default MobileHeader;